import type { Plugin } from '@nuxt/types';
import { NEW_SUPER_INVITES_TOOLTIP, PORTFOLIO_HEADER_MENU_TOOLTIP } from '~/components/common/constants';

const ONBOARDING_TOOLTIPS = new Set([
  PORTFOLIO_HEADER_MENU_TOOLTIP,
  // WAR_ROOM_DEALS_TOOLTIP,
  // WAR_ROOM_COMMISSION_TOOLTIP,
  NEW_SUPER_INVITES_TOOLTIP,
  // WAR_ROOM_MEGATHREADS_TOOLTIP,
]);

const bravadoTooltip: Plugin = ({ app: { store } }, inject) => {
  const isPresent = (tooltip: string) => {
    return store?.$auth.loggedIn && store.$auth.user?.tooltips?.includes(tooltip);
  };

  const close = async (tooltip: string) => {
    if (isPresent(tooltip) || !store?.$auth.user?.tooltips) return;

    const user = {
      ...store.$auth.user,
      tooltips: [...store.$auth.user.tooltips, tooltip],
    };

    store.$auth.$storage.setState('user', user);
    await store.$api.$get(`/profile/tooltips/complete.json?task=${tooltip}`);

    if (ONBOARDING_TOOLTIPS.has(tooltip)) {
      store.dispatch('ui/showNextOnboardingTooltip');
    }
  };

  inject('tooltip', { close, isPresent });
};

export default bravadoTooltip;
